import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTenant } from '../../contexts/TenantContext';
import { gradientTextSx } from '../../utils/textStyles';

const OpeningHoursItem = ({ day, hours }) => {
  const { displayConfig, homePage } = useTenant();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ p: 2 }}
    >
      <Typography fontSize={24} fontWeight="medium" sx={gradientTextSx(displayConfig, homePage?.openingHoursColor)}>{day}</Typography>
      <Typography>{hours}</Typography>
    </Stack>
  );
}

export default OpeningHoursItem;